import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { SpecFieldNames } from '../../../../../../order-builder/modules/specification/constants/specification-field-names.enum';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { RmsMaximumCapacityProvider } from '../../../providers/rms-maximum-capacity.provider';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';

@Injectable()
export class RmsHandleMaximumCapacity implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    const quantityField = form.config.find(
      (control) => control.name === SpecFieldNames.QUANTITY,
    ) as FieldInputNumberConfig;
    if (quantityField.max instanceof RmsMaximumCapacityProvider.RmsMaximumCapacityBase) {
      quantityField.max.unitSubject.next();
    }
    if (quantityField.message instanceof RmsMaximumCapacityProvider.RmsMaximumCapacityBase) {
      quantityField.message.unitSubject.next();
    }
  }
}
